/**
 * InviteEmployees
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button, ListGroup, FormCheck } from 'react-bootstrap';
import { useApi2 } from 'containers/Api2/index.js';
import { EMPLOYEE_ROLE } from 'containers/User/constants.js';
import Breadcrumbs from 'components/layout/Breadcrumbs/index.jsx';
import UserAvatar from 'components/user/UserAvatar/index.jsx';
import useCheckbox from 'utils/useCheckbox.js';
import { idValues } from 'utils/arrays.js';
import messages from './messages.js';
import InviteFrame from './InviteFrame.jsx';
import EmailInvite from './EmailInvite/index.jsx';

const LimitHeight = styled.div`
  max-height: calc(100vh - 500px);
  overflow-y: auto;
`;

function InviteEmployees(props) {
  const { setMeta } = props;

  const title = messages.inviteEmployees;
  const parts = [
    { href: '/admin/users#employee', label: messages.users },
    { label: title },
  ];
  useEffect(() => {
    setMeta({
      title,
      header: <Breadcrumbs parts={parts} />,
    });
  }, []);
  const users = useApi2({ url: `sa/users?type=${EMPLOYEE_ROLE}&active=false&offset=0&limit=20`, version: 2, autoNext: 20 });
  const { onCheck, countSelected, hasSelected, selected, selectedString } = useCheckbox(users);

  const printLink = `#print/employee/${selectedString}`;
  return (
    <InviteFrame className="align-items-start" responsive>
      <InviteFrame.Print className="card py-4 align-items-center">
        <p className="form-text px-4 pb-3"><FormattedMessage {...messages.printEmployees} /></p>
        <ListGroup className="text-start">
          <ListGroup.Item className="d-flex">
            <FormCheck type="checkbox" className="mb-0" id="check-all" onChange={(v) => onCheck(v)} checked={hasSelected || false} disabled={users.loading || users.hasMore} label="" />
            <span className="fw-semibold ms-5 me-2"><FormattedMessage {...messages.employee} /></span>
            {users.list && `(${countSelected ? `${countSelected}/` : ''}${users.totalCount})`}
          </ListGroup.Item>
          <LimitHeight>
            {idValues(users).map((user) => (
              <ListGroup.Item key={user.id} className="pb-1">
                <FormCheck type="checkbox" id={`check+${user.id}`} onChange={(v) => onCheck(v, user.id)} checked={selected.has(user.id)} label={<UserAvatar user={user} />} />
              </ListGroup.Item>
            ))}
          </LimitHeight>
        </ListGroup>
        <Button variant="primary" disabled={!hasSelected} className="mt-4" href={printLink}><FormattedMessage {...messages.invitePrintButton} /></Button>
      </InviteFrame.Print>
      <InviteFrame.Email className="card py-4 align-items-center">
        <EmailInvite roleName="employee" />
      </InviteFrame.Email>
    </InviteFrame>
  );
}

InviteEmployees.propTypes = {
  setMeta: PropTypes.func,
};

export default InviteEmployees;
